module.exports = __webpack_public_path__ + "img/Copy-icon.b899cedc.svg";